// extracted by mini-css-extract-plugin
export default {"card":"r4-z"};